import * as React from 'react';
import { createRoot } from 'react-dom/client';
import reportWebVitals from './reportWebVitals';
import App from './Components/App';
import './index.css';
import 'react-tooltip/dist/react-tooltip.css';
import { Provider } from 'react-redux';
import { store } from './Store/store';
import { worker } from './MockServer/mock';
import 'bootstrap';

const prepare = async (): Promise<void> => {
  if (Object.keys(worker).length !== 0) {
    await worker.start();
  }
};

prepare().then(() => {
  const root = createRoot(document.getElementById('root'));
  root.render(
    <React.StrictMode>
      <Provider store={store}>
        <App />
      </Provider>
    </React.StrictMode>
  );
});

// If you want to start measuring performance in your app, pass a function
// to log results (for example: reportWebVitals(console.log))
// or send to an analytics endpoint. Learn more: https://bit.ly/CRA-vitals
reportWebVitals();
